import * as L from 'leaflet';
import 'leaflet.markercluster';
import { FeatureStatusValues } from '../../../models';

/**
 * Factory functions helping kp-map-features controller
 */

export const emptyClusterGroup = (): L.FeatureGroup => {
    // todo: fix
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - Clusters plugin is not typed
    return L.markerClusterGroup({
        disableClusteringAtZoom: 18,
        animate: true,
        maxClusterRadius: 20,
        zoomToBoundsOnClick: true,
        spiderfyOnMaxZoom: false,
        iconCreateFunction: (cluster: any) => {
            const children = cluster
                .getAllChildMarkers()
                .filter((marker: L.Marker) => marker.feature?.properties?.type === 'connector');
            const markerCount = children.length;
            const maxStatus = Math.max(
                ...children.map((marker: L.Marker) => FeatureStatusValues[marker.feature.properties.status])
            );
            const maxStatusMarkerCount = children.filter(
                (marker: L.Marker) => marker.feature.properties.status === FeatureStatusValues[maxStatus]
            ).length;
            return L.divIcon({
                html: `<div class="location-cluster status-${FeatureStatusValues[maxStatus]}">
                        ${maxStatusMarkerCount} / ${markerCount}
                    </div>`,
            });
        },
    });
};
